// extracted by mini-css-extract-plugin
module.exports = {"fancy":"Link_fancy__LdmrH","heading":"Link_heading__XuXwp","image":"Link_image__eIGJr"};